.notice {
  align-items: flex-start;
  background: var(--color-tertiary-background);
  border: 2px solid var(--color-border);
  border-radius: 6px;
  display: flex;
  gap: 0.625rem;
  padding: 0.75rem 1.25rem;
}

.notice svg {
  color: var(--color-border);
  flex-shrink: 0;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.description {
  margin: 0;
}

.actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
